import { userIsAuthorised } from '../../van-shared/utils/auth'
import { isShelflifeBasedApp, isPsmBasedApp, isPsmFacilityUser } from '../../van-shared/utils/utils'
import { isPlannerUser } from '../../subapps/shipments/common/utils'
import { isLongHaulFeatureEnabled } from '../../subapps/longhaul-orders/common/is-longhaul-enabled'
import { isSelfSignup } from './is-self-signup'

const USER_ROUTES = {
  ALERTS: '/alerts',
  ANALYTICS: '/analytics',
  ORDERS: '/orders',
  LONGHAUL: '/longhaul-orders',
  REPORTING: '/reporting',
  SETTINGS: '/settings',
  SHIPMENTS: '/shipments',
  RETAILER: '/retailer',
  PRODUCTS: '/products',
  PROFILE: '/profile',
  INFORMATION: '/information',
  NOTIFICATIONS: '/notifications',
  CARRIER: '/carrier',
  FACILITY_ORDERS: '/facility-order'
}

const {
  ALERTS,
  ANALYTICS,
  INFORMATION,
  NOTIFICATIONS,
  ORDERS,
  LONGHAUL,
  PRODUCTS,
  PROFILE,
  REPORTING,
  RETAILER,
  SETTINGS,
  SHIPMENTS,
  CARRIER,
  FACILITY_ORDERS // PSM type only
} = USER_ROUTES

const getUserRoutes = (user, config) => {
  if (!user || !config) return []

  const isShelflifeBased = isShelflifeBasedApp(config)
  const isPsmBased = isPsmBasedApp(config)
  const isPsmFacility = isPsmFacilityUser(user)
  const isPlanner = isPlannerUser(user)
  const isRetailer = userIsAuthorised(user, 'feature:userRole:pharmacyUser') && !isPlanner
  const isSelfSignupUser = isSelfSignup(user)

  // adding reporting here because almost all the users need it including retailers
  let allowedRoutes = [PROFILE, REPORTING]

  //  CARRIER
  if (userIsAuthorised(user, 'feature:userRole:psm-carrier')) {
    allowedRoutes = [...allowedRoutes, CARRIER]
  }

  // ALERTS
  if (userIsAuthorised(user, 'feature:qc-alerts')) {
    allowedRoutes = [...allowedRoutes, ALERTS]
  }

  // ANALYTICS & INFORMATION
  if (isPsmBased) {
    allowedRoutes = [...allowedRoutes, ANALYTICS, INFORMATION]
  }

  // LONGHAUL
  if (isLongHaulFeatureEnabled(user, config)) {
    allowedRoutes = [...allowedRoutes, LONGHAUL]
  }

  // NOTIFICATIONS
  if (isShelflifeBased || isPsmFacility) {
    allowedRoutes = [...allowedRoutes, NOTIFICATIONS]
  }

  // ORDERS
  if (
    userIsAuthorised(user, 'feature:orders:requester') ||
    userIsAuthorised(user, 'feature:orders:bulk') ||
    userIsAuthorised(user, 'feature:orders:reset') ||
    userIsAuthorised(user, 'feature:orders:warehouse')

  ) {
    allowedRoutes = [...allowedRoutes, ORDERS]
  }

  // FACILITY_ORDERS
  if (isPsmFacility) {
    allowedRoutes = [...allowedRoutes, FACILITY_ORDERS]
  }

  // PRODUCTS && RETAILER
  if (isShelflifeBased && (isRetailer || isSelfSignupUser)) {
    allowedRoutes = [...allowedRoutes, PRODUCTS, RETAILER]
  }

  // SETTINGS
  if (
    userIsAuthorised(user, 'feature:settings') ||
    userIsAuthorised(user, 'feature:settings:planning-calculator') ||
    userIsAuthorised(user, 'feature:settings:facilities:approvals') ||
    userIsAuthorised(user, 'feature:settings:products:readonly') ||
    userIsAuthorised(user, 'feature:settings:facilities:offline-edits') ||
    userIsAuthorised(user, 'feature:settings:facilities') ||
    userIsAuthorised(user, 'feature:settings:facilities:changes') ||
    userIsAuthorised(user, 'feature:routes') || userIsAuthorised(user, 'feature:routePlanning:edit') || userIsAuthorised(user, 'feature:routePlanning:view') || userIsAuthorised(user, 'feature:carrierManagement') ||
    userIsAuthorised(user, 'feature:orders:warehouse') ||
    userIsAuthorised(user, 'feature:userRole:psm-facility')
  ) {
    allowedRoutes = [...allowedRoutes, SETTINGS]
  }

  // SHIPMENTS
  if (
    userIsAuthorised(user, 'feature:shipments') ||
    userIsAuthorised(user, 'feature:lastMileDeliveries')
  ) {
    allowedRoutes = [...allowedRoutes, SHIPMENTS]
  }

  return allowedRoutes
}

export {
  USER_ROUTES,
  getUserRoutes
}
